// extracted by mini-css-extract-plugin
module.exports = {"seriesListWrapper":"rY","fullWidth":"rZ","seriesListTabWrapper":"r0","tab":"r1","active":"r2"};